import React from 'react';
import UserActivityContext from './context';
import useUserActivityData from './useUserActivityData';

const UserActivityProvider = ({children}) => {
    const getUserActivityData = useUserActivityData();
    return (
        <UserActivityContext.Provider value={getUserActivityData}>
            {children}
        </UserActivityContext.Provider>
    );
};

export default UserActivityProvider;
